import React, { useEffect } from 'react';
import './App.css';
import AppRoutes from './routes/routes';
import { ToastContainer } from 'react-toastify';
import useDateStore from '../src/store/selectedDateStore';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { clearStore } = useDateStore()

  useEffect(() => {
    clearStore()
  }, [])

  return (
    <div className="App">
      <ToastContainer position="bottom-right" />
      <AppRoutes />
    </div>
  );
}

export default App;
